'use strict';

bbw.service.GeoLocationRepository = Class({

    $inject: ['rpcClient', '$q'],

    _rpcClient: undefined,
    _cache: undefined,

    construct: function(rpcClient, $q) {
        this._rpcClient = rpcClient;
        this.$q = $q;
        this._cache = {};
    },

    findCityByGeoIp: function() {
        return this._rpcClient.get('geo/ip').execute().then(function(response) {
            return response.location;
        });
    },

    findCitiesBySubstring: function(substr, limit) {
        return this._getCached('cities:' + limit + ":" + substr, function () {
            return this._rpcClient.get('geo/find/city/{substr}', {
                substr: substr,
                limit: limit
            }).execute().then(function(response) {
                return angular.isArray(response.cities) ? response.cities : [];
            });
        }.bind(this));
    },

    findLocationsBySubstring: function(substr, limit) {
        return this._getCached('locations:' + limit + ":" + substr, function () {
            return this._rpcClient.get('geo/find/location/{substr}', {
                substr: substr,
                limit: limit
            }).execute().then(function(response) {
                return angular.isArray(response.locations) ? response.locations : [];
            });
        }.bind(this));
    },

    getCountries: function() {
        return this._getCached('countries', function() {
            return this._rpcClient.get('geo/countries').execute().then(function(response) {
                return response.countries;
            });
        }.bind(this));
    },

    getRegions: function(countryId) {
        return this._getCached('regions_' + countryId, function() {
            return this._rpcClient.get('geo/regions/' + countryId).execute().then(function(response) {
                return response.regions;
            });
        }.bind(this));
    },

    getCities: function(regionId) {
        return this._getCached('cities_' + regionId, function() {
            return this._rpcClient.get('geo/cities/' + regionId).execute().then(function(response) {
                return response.cities;
            });
        }.bind(this));
    },

    _getCached: function(cacheKey, fn) {
        if (angular.isDefined(this._cache[cacheKey])) {
            return this.$q.when(this._cache[cacheKey]);
        }
        return fn().then(function(result) {
            this._cache[cacheKey] = result;
            return result;
        }.bind(this));
    }

});

